import { Fragment, useContext} from 'react';
import { LanguageContext } from '../../index';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FaqSectionS2 from '../../components/FaqSectionS2/FaqSectionS2';
import ContactSection from '../../components/ContactSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';


const ServicePage =() => {
    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    return(
        <Fragment>
            <Navbar hclass={'header-style-2'}/>
            <PageTitle 
                pageTitle={isPolish ? 'Usługi' : 'Services'} 
                pagesub={isPolish ? 'Nasza oferta' : 'Our offer'}
            /> 
            <FaqSectionS2 />
            <ServiceSection/>
            <ContactSection />
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServicePage;
